<div>
    <h2>{{'global.cultivos' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'informe-cultivos.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'informe-cultivos.filters.campanya' | translate}} *</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanya" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'informe-cultivos.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.provincia' | translate}}</label>
                <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')"
                    [disabled]="disabledProvincias" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.municipio' | translate}}</label>
                <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')"
                    [disabled]="disabledMunicipios" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <!-- <div class="entry-3">
                <label>{{'global.cultivo' | translate}}</label>
                <app-filterable-list [itemsList]="cultivos" [selectedItem]="filtersForm.get('cultivo')"
                    [disabled]="disabledCultivos" [placeHolder]="false">
                </app-filterable-list>
            </div> -->
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.finca' | translate}}</label>
                <input type="text" formControlName="desFinca">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'informe-cultivos.filters.productor' | translate}}</label>
                <input type="text" formControlName="desProductor">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'informe-cultivos.filters.licencia' | translate}}</label>
                <input type="text" formControlName="nLicencia">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
      <i class="fas fa-file-pdf"
          [ngClass]="{'disabled': !cultivosList || (cultivosList && cultivosList.lsTotales.length < 1)}"
          (click)="exportPdfOrCsv('Pdf')" title="{{'titles.exportarPDF' | translate}}"></i>
      <i class="fas fa-file-csv"
          [ngClass]="{'disabled': !cultivosList || (cultivosList && cultivosList.lsTotales.length < 1)}"
          (click)="exportPdfOrCsv('Csv')" title="{{'titles.exportarCSV' | translate}}"></i>
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <section class="no-data" *ngIf="!cultivosList || cultivosList.length === 0">
        {{'global.noContent' | translate}}
    </section>
    <content class="tabs" *ngIf="cultivosList">
        <form>
            <h3>{{'informe-cultivos.totales.titulo' | translate}}</h3>
            <section class="info-framed">
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'informe-cultivos.totales.designados' | translate}}</label>
                    <span>{{cultivosList.totalKgDesignados ? (cultivosList.totalKgDesignados | number : '1.2-2': defaultLanguage) :
                        0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'global.confeccionadoKg' | translate}}</label>
                    <span>{{cultivosList.totalKgImpresos ? (cultivosList.totalKgImpresos | number : '1.2-2': defaultLanguage) :
                        0}}</span>
                </div>
                <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-3'">
                    <label>{{'informe-cultivos.totales.aforo' | translate}}</label>
                    <span>{{cultivosList.totalKgAforo ? (cultivosList.totalKgAforo | number : '1.2-2': defaultLanguage) :
                        0}}</span>
                </div>
            </section>
        </form>
        <div class="table-wrapper">
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th class="icon"></th>
                            <!-- <th class="string sortable" (click)="toOrderBy('2')" [appSort]="cultivosList.lsTotales" data-order="desc" data-name="desProvincia">
                              {{'global.provincia' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('2')"></i>
                              </div>
                            </th> -->
                            <th class="string sortable" (click)="toOrderBy('3', 'x=> x.desMunicipio')">
                              {{'global.municipio' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('3')"></i>
                              </div>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('4', 'x=> x.desMarca')">
                              {{'informe-cultivos.table.marca' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('4')"></i>
                              </div>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('5', 'x=> x.codigoGsv')">
                              {{'informe-cultivos.table.codigoGsv' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('5')"></i>
                              </div>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('6', 'x=> x.desFinca')">
                              {{'global.finca' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('6')"></i>
                              </div>
                            </th>
                            <th class="string sortable" (click)="toOrderBy('7', 'x=> x.desProductor')">
                              {{'informe-cultivos.table.productor' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('7')"></i>
                              </div>
                            </th>
                            <th class="number sortable" (click)="toOrderBy('8', 'x=> x.aforo')">
                              {{'informe-cultivos.table.aforo' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('8')"></i>
                              </div>
                            </th>
                            <th class="number sortable" (click)="toOrderBy('9', 'x=> x.sumaKgDesignados')">
                              {{'informe-cultivos.table.designado' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('9')"></i>
                              </div>
                            </th>
                            <th class="number sortable" (click)="toOrderBy('10', 'x=> x.sumaKgImpresosEfectivos')">
                              {{'global.confeccionadoKg' | translate}}
                              <div class="sortable-icons">
                                <i [ngClass]="getIcon('10')"></i>
                              </div>
                            </th>
                            <th class="action-short">
                            </th>
                        </tr>
                    </thead>
                    <tbody class="clickable" *ngFor="let cultivo of cultivosList.lsTotales; let i = index; trackBy: trackByCultivoId">
                        <tr *ngIf="i < lastItemList && i >= firstItemList" (click)="showDetails(i);"
                            [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                            <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                                title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                            </td>
                            <!-- <td class="string">{{cultivo.desProvincia}}</td> -->
                            <td class="string" title="{{cultivo.desMunicipio}} ({{cultivo.desProvincia}})">{{cultivo.desMunicipio}}</td>
                            <td class="string">{{cultivo.desMarca}}</td>
                            <td class="string">{{cultivo.codigoGsv}}</td>
                            <td class="string">{{cultivo.desFinca}}</td>
                            <td class="string">{{cultivo.desProductor}}</td>
                            <td class="number">{{cultivo.aforo  | number : '1.2-2': defaultLanguage}}</td>
                            <td class="number">{{cultivo.sumaKgDesignados  | number : '1.2-2': defaultLanguage}}</td>
                            <td class="number">{{cultivo.sumaKgImpresosEfectivos  | number : '1.2-2': defaultLanguage}}</td>
                            <td class="action-short">
                                <i class="fas fa-stream" app-click-stop-propagation (click)="openTabs(i)"
                                   title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                            </td>
                        </tr>
                        <tr *ngIf="dropdownInfo === i">
                            <td colspan="11">
                                <div class="detail">
                                    <div class="title">{{'global.masInformacion' | translate}}</div>
                                    <div class="block-inline">
                                      <label>{{'informe-cultivos.table.id' | translate}}</label>
                                      <p>{{cultivo.cultivoId}}</p>
                                    </div>
                                    <div class="block-inline">
                                        <label>{{'informe-cultivos.table.superfice' | translate}}</label>
                                        <p>{{cultivo.superficie}}</p>
                                    </div>
                                    <div class="block-inline">
                                        <label>{{'global.provincia' | translate}}</label>
                                        <p>{{cultivo.desProvincia}}</p>
                                    </div>
                                    <div class="block-inline">
                                        <label>{{'informe-cultivos.table.poligono' | translate}}</label>
                                        <p>{{cultivo.poligonoCatastral}}</p>
                                    </div>
                                    <div class="block-inline">
                                        <label>{{'informe-cultivos.table.parcela' | translate}}</label>
                                        <p>{{cultivo.parcelaCatastral}}</p>
                                    </div>
                                    <div class="block-inline">
                                        <label>{{'informe-cultivos.table.nPlantas' | translate}}</label>
                                        <p>{{cultivo.nPlantas}}</p>
                                    </div>
                                    <div class="block-inline">
                                      <label>{{'informe-cultivos.table.licencia' | translate}}</label>
                                      <p>{{cultivo.nLicencia}}</p>
                                    </div>
                                    <div class="block-inline"></div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="dropdownSection === i">
                            <td colspan="11">
                                <section class="tabs">
                                    <ul>
                                        <li [ngClass]="{'active': pestanaActiva[i] === 1}">{{'informe-cultivos.etiquetadores.titulo' | translate}}</li>
                                    </ul>
                                    <content>
                                        <app-etiquetadores-cultivo *ngIf="pestanaActiva[i] === 1" [etiquetadoresCultivo]="cultivo.designadoPorAlmacen"></app-etiquetadores-cultivo>
                                    </content>
                                </section>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <app-paginator
            *ngIf="(cultivosList && cultivosList.lsTotales.length > 0)"
            [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
            [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
            (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    </content>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes"
        (closed)="showError=$event;showWarning=$event">
    </app-toast>
</div>
